<style>
  .company-dialog {
    width: 390px;
    height: 370px;
    padding: 30px 30px 10px 30px;
  }
</style>
<style scoped>
  .btn {
    background: #0077db;
    width: 337px;
    height: 40px;
    border-radius: 5px;
    color: #fff;
    text-align: center;
    font-size: 20px;
    line-height: 40px;
  }
</style>
<template>
  <div id="company-dialog">
    <el-dialog :title="title" ref="dialog" custom-class="company-dialog">
      <el-form style="margin-top: 5px">
        <el-form-item>
          <el-input auto-complete="off" placeholder="企业名称（必填）" v-model="company.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input auto-complete="off" placeholder="联系人（必填）" v-model="company.legalPerson"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input auto-complete="off" placeholder="邮寄地址（非必填）" v-model="company.address"></el-input>
        </el-form-item>
      </el-form>
      <el-button id="btn-submit" type="primary"
                 v-on:click="submit"
                 style="width: 100%;background: #007fff;border-radius: 2px;border: none;padding: 0.7em;font-size: 18px;"
                 :loading="inSubmit">{{ inSubmit ? "提交中" : "确定" }}


      </el-button>
    </el-dialog>
  </div>
</template>
<script>
  import companyApi from '../api/company'
  export default {
    data () {
      return {
        company: {
          legalPerson: '',
          name: '',
          address: '',
          customerId: '',
          telephone: ''
        },
        inEdit: false,
        title: '新增公司',
        inSubmit: false
      }
    },
    methods: {
      validate () {
        if (!this.company.legalPerson || !this.company.name) {
          this.$message({
            message: '请检查输入',
            type: 'warning'
          })
          return false
        }
        return true
      },
      openDialog (company) {
        this.inSubmit = false
//        debugger
//        console.log('openDialog')
        if (company) {
          this.company = company
          this.inEdit = true
        } else {
          this.company = {
            legalPerson: '',
            name: '',
            address: ''
          }
          this.inEdit = false
        }
        this.$refs.dialog.open()
      },
      submit () {
        if (!this.validate()) return
        this.inSubmit = true
        let vm = this
        let companies = JSON.parse(window.localStorage.getItem('companies'))
        if (this.inEdit) {
          companyApi.putCompany(this.company, bd => {
              vm.$store.commit('UPDATE_COMPANY', bd)
              vm.$message({
                message: '更新成功',
                type: 'success'
              })
              for (var i = 0; i < companies.length; i++) {
                if (companies[i].customerId === this.company.customerId) {
                  companies[i].legalPerson = this.company.legalPerson
                  companies[i].name = this.company.name
                  companies[i].address = this.company.address
                  window.localStorage.setItem('companies', JSON.stringify(companies))
                  break
                }
              }
              vm.$refs.dialog.close()
            },
            bd => {
              this.$message.error('失败,' + bd.message)
            })
        } else {
          this.company.employeeId = 'admin'

          companyApi.postCompany(this.company, bd => {
              vm.$store.commit('ADD_COMPANY', bd)
              vm.$message({
                message: '添加成功',
                type: 'success'
              })
              vm.$refs.dialog.close()
              vm.$emit('submit')
            },
            bd => {
              this.$message.error('失败,' + bd.message)
            })
        }
        this.inSubmit = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CompanyDialog.vue?9dd896c4